const API_BASE_URL = "https://qt3zit1045.execute-api.ap-northeast-1.amazonaws.com/prod";

export async function fetchEvents() {
    const response = await fetch(`${API_BASE_URL}/events`);
    return response.json();
}

export async function fetchEvent(eventId) {
    const response = await fetch(`${API_BASE_URL}/events/${eventId}`);
    return response.json();
}

export async function fetchItems(eventId) {
    const response = await fetch(`${API_BASE_URL}/events/${eventId}/items`);
    return response.json();
}

export async function createEvent(eventName, eventDate) {
    const response = await fetch(`${API_BASE_URL}/events`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ eventName, eventDate }),
    });
    return response.json();
}

export async function addItem(eventId, itemId, itemName, category1, category2, category3, quantity, imageUrl, purchaseUrl) {
    console.log("🛠️ 送信するデータ_itemName:", itemName);
    const response = await fetch(`${API_BASE_URL}/events/${eventId}/items`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ itemName, itemId, category1, category2, category3, quantity, imageUrl, purchaseUrl }),
    });
    return response.json();
}


export async function deleteItem(eventId, itemId) {
    const response = await fetch(`${API_BASE_URL}/events/${eventId}/items/${itemId}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" }
    });

    if (!response.ok) {
        throw new Error(`HTTPエラー: ${response.status}`);
    }

    return response.json();
}


export async function updateItem(eventId, itemId, updatedData) {
    const response = await fetch(`${API_BASE_URL}/events/${eventId}/items/${itemId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedData),
    });

    if (!response.ok) {
        throw new Error(`HTTPエラー: ${response.status}`);
    }

    return response.json();
}


export async function fetchItem(eventId, itemId) {
    const response = await fetch(`${API_BASE_URL}/events/${eventId}/items/${itemId}`);

    if (!response.ok) {
        throw new Error(`HTTPエラー: ${response.status} - ${await response.text()}`);
    }

    return response.json();
}
